import { FLOW_STEPS, STATUS_META, formatDateTime } from "@/lib/format";
import { Check } from "lucide-react";

export const StatusTimeline = ({ history = [], currentStatus }) => {
  const reached = new Set(history.map((h) => h.status));
  const cancelled = currentStatus === "CANCELLED";
  const timeByStatus = {};
  history.forEach((h) => {
    timeByStatus[h.status] = h.created_at;
  });

  return (
    <div className="flex flex-col" data-testid="shipment-timeline">
      {FLOW_STEPS.map((step, i) => {
        const done = reached.has(step);
        const isCurrent = step === currentStatus;
        const m = STATUS_META[step];
        const last = i === FLOW_STEPS.length - 1;
        return (
          <div key={step} className="flex gap-3" data-testid={`timeline-step-${step}`}>
            <div className="flex flex-col items-center">
              <div
                className="grid h-8 w-8 shrink-0 place-items-center rounded-full border-2 transition-all"
                style={{
                  borderColor: done || isCurrent ? m.border : "#333",
                  background: isCurrent ? m.border : done ? "rgba(255,255,255,0.03)" : "transparent",
                }}
              >
                {done && !isCurrent ? (
                  <Check size={15} color={m.color} strokeWidth={3} />
                ) : (
                  <span
                    className="h-2.5 w-2.5 rounded-full"
                    style={{ background: isCurrent ? "#0B0B0B" : done ? m.color : "#444" }}
                  />
                )}
              </div>
              {!last && (
                <div
                  className="w-0.5 grow"
                  style={{ minHeight: 26, background: done ? m.border : "#2a2a2a" }}
                />
              )}
            </div>
            <div className={`pb-6 ${done || isCurrent ? "" : "opacity-40"}`}>
              <div
                className="font-heading text-sm font-bold"
                style={{ color: isCurrent ? m.color : "#fff" }}
              >
                {m.label}
              </div>
              <div className="text-xs text-gray-500">
                {timeByStatus[step] ? formatDateTime(timeByStatus[step]) : "Pendiente"}
              </div>
            </div>
          </div>
        );
      })}
      {cancelled && (
        <div className="mt-1 rounded-xl border border-red-500/40 bg-red-500/10 px-3 py-2 text-sm font-semibold text-red-400">
          Servicio cancelado
        </div>
      )}
    </div>
  );
};
